import { render, staticRenderFns } from "./OfficeHoursDay.vue?vue&type=template&id=03357504&scoped=true&"
import script from "./OfficeHoursDay.vue?vue&type=script&lang=ts&"
export * from "./OfficeHoursDay.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeHoursDay.vue?vue&type=style&index=0&id=03357504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03357504",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
